module.exports = __webpack_public_path__ + "img/contact_03.7a10c815.png";